import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { User } from '../model/user.model';
import { ServiceScheduleSetting, ScheduleSearch, EmailNotifyList } from "../model/notification-setting.model";

const API_URL = environment.apiUrl;
const httpOptions = {
    headers: new HttpHeaders(
        {
            'Content-Type': 'application/json',
        }
    )
};

@Injectable()
export class NotificationSettingService {
    private Url = '';  // URL to web api
    currentUser: User;

    constructor(
        private http: HttpClient) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.Url = API_URL + '/' + (this.currentUser.CompanyID ? this.currentUser.CompanyID.toString() : "1") + '/notification';
    }

    UpdateScheduleSetting(data: ServiceScheduleSetting): Observable<any> {
        return this.http.post<any>(this.Url + "/UpdateScheduleSetting", data, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    SaveEmailNotifyList(data: EmailNotifyList): Observable<any> {
        return this.http.post<any>(this.Url + "/SaveEmailNotifyList", data, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetScheduleList(search: ScheduleSearch): Observable<ServiceScheduleSetting[]> {
        return this.http.post<ServiceScheduleSetting[]>(this.Url + "/GetScheduleList", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetEmailNotifyList(search: ScheduleSearch): Observable<EmailNotifyList[]> {
        return this.http.post<EmailNotifyList[]>(this.Url + "/GetEmailNotifyList", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetScheduleDetail(search: ScheduleSearch): Observable<ServiceScheduleSetting> {
        return this.http.post<ServiceScheduleSetting>(this.Url + "/GetScheduleDetail", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }


}


// WEBPACK FOOTER //
// ./src/app/services/notification-setting.service.ts